import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {RoleModel} from '../../api/role-model';
import {RolesService} from '../../api/roles.service';

@Component({
  selector: 'app-user-roles',
  templateUrl: './user-roles.component.html',
  styleUrls: ['./user-roles.component.scss']
})
export class UserRolesComponent implements OnInit {
  // tslint:disable-next-line:variable-name
  private _roleId: number;
  @Input()
  get roleId(): number {
    return this._roleId;
  }

  set roleId(value: number) {
    this._roleId = value;
    this.roleIdChange.emit(value);
  }

  @Output() roleIdChange: EventEmitter<number> = new EventEmitter<number>();

  roles: RoleModel[] = [];

  constructor(private rolesService: RolesService) { }

  async ngOnInit() {
    this.roles = [];
    this.roles = (await this.rolesService.get().toPromise());
  }
}
